import {NgModule} from '@angular/core';
import {SafeHtmlPipe} from './safeHtml.pipe';
import {NgGenericPipe} from './ng-generic-pipe.pipe';
import {CoreSecurePipe} from './secure.pipe';
import {TruncateCorePipe} from './truncate.pipe';
import {ReturnPipe} from '@shared/pipes/generic/return.pipe';

export const GENERIC_PIPES = [NgGenericPipe, SafeHtmlPipe, CoreSecurePipe, TruncateCorePipe,ReturnPipe];

@NgModule({
  declarations: GENERIC_PIPES,
  imports: [],
  exports: GENERIC_PIPES,
})
export class NgGenericPipeModule {}

export { NgGenericPipe } from './ng-generic-pipe.pipe';
